import React, { Component, ReactNode } from 'react'
import Button from 'core/components/buttons/Button'
import AnalyticsHelper from 'utils/AnalyticsHelper'
import Icon from 'core/components/icons/Icon'
import { docCookies } from 'utils/docCookies'

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
  id: number
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    id: 0
  }

  public static getDerivedStateFromError(_: Error): State {
    const id = new Date().getTime()

    return { hasError: true, id }
  }

  public componentDidCatch(error: Error) {
    const authToken = docCookies.getItem('auth_token')
    AnalyticsHelper.trackEvent('Server Error on Dashboard', {
      stack: window?.btoa(error?.stack ?? ''),
      id: this.state.id,
      authToken,
      pathname: window?.location?.pathname,
      search: window?.location?.search
    })
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex justify-center items-center gap-5 w-screen h-[100vh] flex-col text-center">
          <Icon
            name="exclamation-mark"
            color="text-white"
            className="bg-dark-4 rounded-full p-1"
          />
          <h1 className="text-dark-4 m-0">Server error</h1>
          <div>
            <p>Oh no! Looks like something broke.</p>
            <p>
              Try refreshing the page and if you need more help{' '}
              <a href="mailto:support@everlance.com" className="underline">
                contact support
              </a>
            </p>
            <p>
              and reference this number{' '}
              <span className="text-dark-4">{this.state.id}</span>.
            </p>
          </div>
          <Button
            variant="primary"
            onClick={() => {
              window.location.assign('/dashboard')
            }}
          >
            Back to home
          </Button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
